import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChevronTopSmall: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="chevron-top-small"><path fillRule="evenodd" clipRule="evenodd" d="M12.5303 11.5908C12.2374 11.2979 11.7626 11.2979 11.4697 11.5908L8.53033 14.5301C8.23744 14.823 7.76256 14.823 7.46967 14.5301C7.17678 14.2372 7.17678 13.7623 7.46967 13.4694L10.409 10.5301C11.2877 9.65142 12.7123 9.65143 13.591 10.5301L16.5303 13.4694C16.8232 13.7623 16.8232 14.2372 16.5303 14.5301C16.2374 14.823 15.7626 14.823 15.4697 14.5301L12.5303 11.5908Z" fill="currentColor"/></CentralIconBase>;
};

export default IconChevronTopSmall;
